import WriteLectureSimpleArea from "@/pages/comp/edu/lecture/common/write_simple";

function WriteLectureSimplePopup(props:any){
   let myProps={
    closePopup:()=>{},
    callback_refresh:(inData:any)=>{},
    row_data: {},
    is_update: false,
    ...props
  };
  
  return (
  <div>
    <WriteLectureSimpleArea
      row_data={myProps.row_data}
      is_update={myProps.is_update}
      callback_refresh={myProps.callback_refresh}
      close_func={myProps.closePopup}
    ></WriteLectureSimpleArea>
  </div>
  );
};
export default WriteLectureSimplePopup;